export function mapVerificationProduct(product) {
  if (product == null || typeof product !== "object") {
    return null;
  }

  if (product.id == null || product.id === "") {
    return null;
  }

  return {
    id: Number(product.id),
    sku: product.sku != null ? String(product.sku) : "",
    product_code: product.product_code != null ? String(product.product_code) : "",
    country_id: product.country_id != null ? String(product.country_id) : "",
  };
}

export function mapVerificationCenterEntity(entity) {
  if (!entity || typeof entity !== "object" || Array.isArray(entity)) {
    return entity;
  }

  return {
    ...entity,
    product: mapVerificationProduct(entity.product),
  };
}

export function mapVerificationCenterList(items) {
  if (!Array.isArray(items)) {
    return items;
  }

  return items.map(mapVerificationCenterEntity);
}

export function mapVerificationMessage(message) {
  if (!message || typeof message !== "object") {
    return message;
  }

  if (!message.is_verification_request && !Object.prototype.hasOwnProperty.call(message, "product")) {
    return message;
  }

  return {
    ...message,
    product: mapVerificationProduct(message.product),
  };
}

export function mapVerificationMessages(items) {
  if (!Array.isArray(items)) {
    return items;
  }

  return items.map(mapVerificationMessage);
}
